"use client";

import { notojp, roboto, prophet } from "./_fonts/fonts";
import ErrorPage from "./error";
import "./globals.css";

export default function GlobalErrorPage({
  error,
}: {
  error: Error & { digest?: string };
}) {
  return (
    <html lang="ja">
      <body
        className={`font-notojp accent-sorange antialiased ${notojp.variable} ${roboto.variable} ${prophet.variable}`}
      >
        <ErrorPage error={error} />
      </body>
    </html>
  );
}
